import { reports } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IReports } from "../../models/master/reports";

export default new (class ReportService {
  public getReport = async (id: number): Promise<IApiResponse<IReports>> => {
    try {
      let endPoint = urlBinder(reports.GET_REPORT, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IReports>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IReports>;
      } else {
        throw error;
      }
    }
  };

  public getReports = async (
    configUserRole?: number,
    pageBlockId?: number,
    noOfItems?: number,
    reportFrequency?: number
  ): Promise<IApiResponse<Array<IReports>>> => {
    try {
      let endPoint = urlBinder(reports.GET_ALL_REPORTS, [configUserRole,pageBlockId,noOfItems,reportFrequency]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IReports>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IReports>>;
      } else {
        throw error;
      }
    }
  };

  public createReport = async (
    data: any
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = reports.CREATE_REPORT;
      const response = await APIService.postFormData(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public updateReport = async (
    data: any,
    id: number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(reports.UPDATE_REPORT, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public updateReportPriority = async (
    data: any
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = reports.UPDATE_REPORT_PRIORITY;
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteReport = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(reports.DELETE_REPORT, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };
})();
